import { Link } from 'react-router';
import { LexGatWordmark } from './Logo';
import { appUrl } from '../lib/domains';

export default function MarketingFooter() {
  return (
    <footer className="bg-slate-50 border-t border-gray-200 py-16 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="col-span-1 md:col-span-2">
          <Link to="/" className="scale-90 origin-left cursor-pointer mb-4 inline-block" discover="none">
            <LexGatWordmark className="h-8 w-auto" tone="on-light" />
          </Link>
          <p className="text-slate-600 text-[15px] font-medium leading-relaxed max-w-sm mb-6">
            Legal Gateway for litigation lawyers in Pakistan.
          </p>
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} LexGat. All rights reserved.
          </p>
        </div>
        
        <div>
          <h4 className="font-semibold text-slate-900 mb-4 tracking-tight">Platform</h4>
          <div className="flex flex-col gap-3 text-[15px] text-slate-600 font-medium tracking-tight">
            <Link to="/" className="hover:text-slate-900 transition-colors text-left w-fit" discover="none">Home</Link>
            <Link to="/how-it-works" className="hover:text-slate-900 transition-colors text-left w-fit" discover="none">How It Works</Link>
            <Link to="/about" className="hover:text-slate-900 transition-colors text-left w-fit" discover="none">About Us</Link>
            <a href={appUrl('/login')} className="hover:text-slate-900 transition-colors text-left w-fit">Login</a>
          </div>
        </div>

        <div>
          <h4 className="font-semibold text-slate-900 mb-4 tracking-tight">Legal</h4>
          <div className="flex flex-col gap-3 text-[15px] text-slate-600 font-medium tracking-tight">
            <Link to="/privacy-policy" className="hover:text-slate-900 transition-colors text-left w-fit" discover="none">Privacy Policy</Link>
            <Link to="/terms-conditions" className="hover:text-slate-900 transition-colors text-left w-fit" discover="none">Terms & Conditions</Link>
            <Link to="/contact" className="hover:text-slate-900 transition-colors text-left w-fit" discover="none">Contact</Link>
          </div>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-gray-200">
        <p className="text-slate-500 text-xs text-center max-w-3xl mx-auto leading-relaxed">
          Disclaimer: LexGat is a legal practice technology platform. It does not provide legal advice and does not replace the professional judgment of a qualified lawyer.
        </p>
      </div>
    </footer>
  );
}
